import React, { ReactNode } from 'react';
import classNames from 'classnames';
// @ts-ignore
import WarningIcon from '../../images/icons/warning.svg';
import CloseIcon from '@material-ui/icons/Close';

import './AnnouncementBanner.scss';
import { TestID } from '../../testID';

export const AnnouncementBannerPositioner: React.FC<{
  children: ReactNode;
  isExpended: boolean;
}> = ({ children, isExpended }) => (
  <div
    className={classNames(
      'announcement-banner-positioner',
      isExpended ? 'announcement-banner-wrapper-opened' : 'announcement-banner-wrapper-closed'
    )}
  >
    {children}
  </div>
);

const Announcements: React.FC<{
  announcements: string[];
  setPreventAutoClose: (preventAutoClose: boolean) => void;
}> = ({ announcements, setPreventAutoClose }) => (
  <ul id="announcements" onClick={() => setPreventAutoClose(true)} tabIndex={0}>
    {announcements.map((announcement, index) => (
      <li key={index} data-testid={TestID.AnnouncementBannerAnnouncementItem}>
        <div style={{ display: 'flex' }}>
          <div style={{ paddingRight: '6px' }}>
            <span>&#9656;</span>
          </div>
          <div>{announcement}</div>
        </div>
      </li>
    ))}
  </ul>
);

export const AnnouncementBannerToggler: React.FC<{
  isExpended: boolean;
  handleToggle: () => void;
}> = ({ isExpended, handleToggle }) => (
  <div
    className="announcement-banner-toggler-button"
    data-testid={TestID.AnnouncementBannerTogglerButton}
  >
    <button
      className="btn-link"
      onClick={handleToggle}
      title={
        isExpended ? 'Toggle collapse announcement banner' : 'Toggle expend announcement banner'
      }
    >
      <WarningIcon
        className="announcement-banner-toggler-icon"
        data-testid={TestID.AnnouncementBannerTogglerButtonIcon}
      />
    </button>
  </div>
);

const AnnouncementBannerCloseButton: React.FC<{ handleToggle: () => void }> = ({
  handleToggle,
}) => (
  <button
    className="btn-link announcement-banner-close-button"
    title="Toggle close announcement banner"
    onClick={handleToggle}
    data-testid={TestID.AnnouncementBannerCloseButton}
  >
    <CloseIcon width="30px" />
  </button>
);

export const AnnouncementBanner: React.FC<{
  testId?: string;
  announcements: string[];
  setPreventAutoClose: (preventAutoClose: boolean) => void;
  handleToggle: () => void;
}> = ({ testId, announcements, setPreventAutoClose, handleToggle }) => (
  <div className="announcement-banner-wrapper" data-testid={testId}>
    <header className="announcement-banner-header">
      <h2>Announcements</h2>
      <AnnouncementBannerCloseButton handleToggle={handleToggle} />
    </header>
    <main className="announcement-banner-content">
      <Announcements announcements={announcements} setPreventAutoClose={setPreventAutoClose} />
    </main>
  </div>
);
